import fetchAPI from '../fetchAPI';

interface callGetBillsProps {
  pageNumber?: number;
  pageSize?: number;
  companyName?: string;
  startDate?: string;
  endDate?: string;
  sortBy?: string | string[];
}

export const callGetBills = async (
  props: callGetBillsProps
): Promise<iResponse<Pagination<Bill>>> => {
  const { pageNumber, pageSize, companyName, startDate, endDate, sortBy } = props;

  const queryParams = new URLSearchParams();
  if (pageNumber) {
    queryParams.append('pageNumber', pageNumber.toString());
  }
  if (pageSize) {
    queryParams.append('pageSize', pageSize.toString());
  }
  if (startDate) {
    queryParams.append('startDate', startDate);
  }
  if (endDate) {
    queryParams.append('endDate', endDate);
  }
  if (sortBy) {
    if (Array.isArray(sortBy)) {
      sortBy.forEach((sort) => queryParams.append('sortBy', sort));
    } else {
      queryParams.append('sortBy', sortBy);
    }
  }

  if (companyName) {
    queryParams.append('companyName', companyName);
  }
  const queryString = queryParams.toString();

  const response: iResponse<Pagination<Bill>> = await fetchAPI({
    method: `GET`,
    route: `bills`,
    queryString
  });

  return response;
};

export default callGetBills;
